import React, { useContext, useEffect, useState } from "react";
import FileContext from "../context/Context";
import { Typography, Box, LinearProgress } from "@mui/material";

const ImageProgressBar = () => {
  const [progressPercentage, setProgressPercentage] = useState(0);
  const { setCapturedInspectionImages, capturedInspectionImages } = useContext(FileContext);

  // Fetch inspectionConfig from localStorage
  const storedConfig = localStorage.getItem("inspectionConfiguration");
  // const storedConfig = localStorage.getItem("inspectionConfig");
  const inspectionConfig = storedConfig
    ? JSON.parse(storedConfig).inspection_config
    : null;

  // Base images (first 8 are always included)
  console.log("86", inspectionConfig);
  let totalImages=6;
//   if (!inspectionConfig) {
//     totalImages = 20;
//   } else {
//     totalImages = 0;
//   }
//   console.log("92", totalImages);

//   if (inspectionConfig) {
//     if (inspectionConfig.selectedItems?.includes("Front Side")) {
//       totalImages+=1;
//     }
//         if (inspectionConfig.selectedItems?.includes("Front Left Side")) {
//       totalImages+=1;
//         }
//         if (inspectionConfig.selectedItems?.includes("Left Side")) {
//       totalImages+=1;
//         }
//         if (inspectionConfig.selectedItems?.includes("Back Left Side")) {
//       totalImages+=1;
//         }
//         if (inspectionConfig.selectedItems?.includes("Back Side")) {
//       totalImages+=1;
//         }
//         if (inspectionConfig.selectedItems?.includes("Back Right Side")) {
//       totalImages+=1;
//         }
//         if (inspectionConfig.selectedItems?.includes("Right Side")) {
//       totalImages+=1;
//         }
//         if (inspectionConfig.selectedItems?.includes("Front Right Side")) {
//       totalImages+=1;
//         }
//     // Add images based on selected items
//     if (inspectionConfig.selectedItems?.includes("Windshield")) {
//       totalImages += 2; // Outer + Inner Windshield
//     }
//     if (inspectionConfig.selectedItems?.includes("Tyres")) {
//       totalImages += 4; // 4 Tyres
//     }
//     if (inspectionConfig.selectedItems?.includes("Odometer")) {
//       totalImages += 1; // Odometer
//     }
//     if (inspectionConfig.selectedItems?.includes("Registration number")) {
//       totalImages += 1; // Registration Plate
//     }
//     if (inspectionConfig.selectedItems?.includes("Chassis")) {
//       totalImages += 1; // Registration Plate
//     }
//     if (inspectionConfig.selectedItems?.includes("Sunroof")) {
//       totalImages += 2; // Registration Plate
//     }
//     if (inspectionConfig.selectedItems?.includes("RC")) {
//       totalImages += 1; // Registration Plate
//     }
//     if (inspectionConfig.selectedItems?.includes("Video of RMP")) {
//       totalImages += 1; // Registration Plate
//     }
//     if (inspectionConfig.selectedItems?.includes("Selfie with the car")) {
//       totalImages += 1; // Registration Plate
//     }
//   }

  useEffect(() => {
    console.log("totalImages", totalImages);
    const capturedCount = capturedInspectionImages.length;
    setProgressPercentage((capturedCount / totalImages) * 100);
  }, [capturedInspectionImages, totalImages]);

  window.addEventListener("popstate", () => {
    console.log("User clicked back button");
    setCapturedInspectionImages([]);
  });

  return (
    <Box
      sx={{
        margin: "auto",
        marginTop: "0.2rem",
        marginBottom: "0.2rem",
        position: "relative",
        width: "13vw",
        height: "10vw",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexDirection: "row",
        borderRadius: "5px",
        padding: "1rem 0.4rem",
        "@media (max-width: 900px)and (orientation: landscape)": {
          width: "20vw",
        },
      }}
    >
      <Box sx={{ flexGrow: 1 }}>
        <LinearProgress
          variant="determinate"
          value={progressPercentage}
          sx={{
            height: 7,
            backgroundColor: "#f0f0f0",
            "& .MuiLinearProgress-bar": {
              backgroundColor: "#FC350B",
            },
          }}
        />
      </Box>
      <Typography variant="body2" sx={{ marginLeft: "10px" }}>
        {Math.round(progressPercentage)}%
      </Typography>
    </Box>
  );
};

export default ImageProgressBar;
